module.exports = __webpack_public_path__ + "static/media/hsbg.0236c406.jpg";